export default __webpack_public_path__ + "static/media/Group 386.73cab39d.svg";